export const MSRP = 'MSRP';
export const SELLING_PRICE = 'Selling Price';
export const COST = 'Cost';
export const ODOMETER = 'Odometer';
